import { SubSink } from 'subsink';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { AuthService, AuthUser } from '@monorepo/ui/auth';
import { ChatBotService } from '../../services/chat-bot.service';

import { ChatBotModel } from '../../models';

@Component({
  selector: 'monorepo-user-chat-list',
  templateUrl: './user-chat-list.component.html',
  styleUrls: ['./user-chat-list.component.scss'],
})
export class UserChatListComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  chatBotList: ChatBotModel[] = [];
  loggedUser: AuthUser;
  selectedChabotUserId: string;

  constructor(
    private authService: AuthService,
    private chatBotService: ChatBotService
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.authService.user.subscribe({
      next: (user: AuthUser): void => {
        if (user) {
          this.loggedUser = user;
          this.getAllChatBotList();
        }
      },
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public getAllChatBotList(): void {
    this.subs.sink = this.chatBotService.getChatBotList().subscribe({
      next: (chabotlist: ChatBotModel[]): void => {
        this.chatBotList = chabotlist;
      },
    });
  }

  public selectChatBot(chatbot: ChatBotModel): void {
    this.selectedChabotUserId = chatbot.userId;
    this.chatBotService.selectedChatbot$.next(chatbot);
  }
}
